import { ShopifyOpenerAppearance } from "../components/ShopifyOpenerAppearance";
import { useTenantRole } from "../lib/useTenantRole";

/** The opener's look in the shop's storefront overlay; admins save, others read. */
export function ShopifyAppearancePage() {
  const { can } = useTenantRole();
  return <ShopifyOpenerAppearance canEdit={can("admin")} />;
}
